import './styles.scss'
import { ReactNode } from 'react'

import * as Dialog from '@radix-ui/react-dialog'
import * as VisuallyHidden from '@radix-ui/react-visually-hidden'

const CLASS_NAME = 'gby-k2g-animation-modal'

export type AnimationPayoutModalProps = {
  children: ReactNode
  description: string
  footer: JSX.Element
  overlayZIndex?: number
  title: string
}

export const StaticAnimationModal = ({
  children,
  description,
  footer,
  overlayZIndex,
  title,
}: AnimationPayoutModalProps) => {
  return (
    <Dialog.Root open={true} onOpenChange={() => {}}>
      <div className={`${CLASS_NAME}__overlay`} style={{ zIndex: overlayZIndex ?? 5 }} />
      <div className={`${CLASS_NAME}`}>
        <VisuallyHidden.Root>
          <Dialog.DialogTitle>{title}</Dialog.DialogTitle>
          <Dialog.Description>{description}</Dialog.Description>
        </VisuallyHidden.Root>
        <div className={`${CLASS_NAME}__top-area`}>{children}</div>
        <div className={`${CLASS_NAME}__bottom-area`}>{footer}</div>
      </div>
    </Dialog.Root>
  )
}
